const TODO_LIST_MODULE_CODES = new Set(['TODO_LIST', 'TODOLIST']);

function normalizeModuleCode(entry) {
  return String(entry?.code ?? entry?.Code ?? entry ?? '')
    .toUpperCase()
    .trim()
    .replace(/\s+/g, '_');
}

function normalizeModuleName(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

export function userHasTodoListModule(user) {
  if (!user) return false;

  const codes = user.activeModuleCodes ?? [];
  if (Array.isArray(codes) && codes.some((entry) => TODO_LIST_MODULE_CODES.has(normalizeModuleCode(entry)))) {
    return true;
  }

  const modules = user.activeModules ?? [];
  if (!Array.isArray(modules)) return false;

  return modules.some((entry) => {
    if (TODO_LIST_MODULE_CODES.has(normalizeModuleCode(entry))) return true;
    const name = normalizeModuleName(
      entry?.ModuleName ??
        entry?.moduleName ??
        entry?.FormTitle ??
        entry?.FormName ??
        entry?.Title ??
        entry?.name ??
        entry?.Name ??
        entry
    );
    return name === 'to-do list' || name === 'todo list' || name.includes('to-do list');
  });
}
